import React, {useState} from "react";
import CountryImg from "../../../assets/country.png";
import { BsBell, BsChevronRight } from "react-icons/bs";
import DetailsComponent from "./DetailsComponent";

const ScoreBox = () => {
  const [showDetails, setShowDetails] = useState(false);
  return (
    <>
      <div className="score-box-header p-2 mt-5 flex justify-between">
        <div>
          <img src={CountryImg} style={{display: "inline", marginRight: 10}} />
          <p style={{display: "inline"}}>England - Premier League</p>
        </div>
        <div>
          <BsChevronRight />
        </div>
      </div>
      <div className={`p-2 mt-5 score-box-content ${!showDetails ? "grid" : "hidden"}`} onClick={() => setShowDetails(!showDetails)}>
        <div>
          <div className="w-2 h-2 rounded-full bg-green-400 inline-block mr-2"></div>
          <p className="font-bold inline">Live</p>
        </div>
        <div>
          <p className="font-bold">35`</p>
        </div>
        <div>
          <p className="block font-bold">Wolverhampton</p>
          <p className="block font-bold">Tottenham</p>
        </div>
        <div className="text-right">
          <p className="block font-bold">0</p>
          <p className="block font-bold">1</p>
        </div>
        <div>
          <BsBell style={{float: "right"}} />
        </div>
      </div>

      <div className={`scores-details ${showDetails ? "block" : "hidden"}`}>
        <DetailsComponent />
      </div>

      <div className={`p-2 mt-5 score-box-content ${!showDetails ? "grid" : "hidden"}`}>
        <div>
          <div className="w-2 h-2 rounded-full bg-green-400 inline-block mr-2"></div>
          <p className="font-bold inline">Live</p>
        </div>
        <div>
          <p className="font-bold">35`</p>
        </div>
        <div>
          <p className="block font-bold">Wolverhampton</p>
          <p className="block font-bold">Tottenham</p>
        </div>
        <div className="text-right">
          <p className="block font-bold">0</p>
          <p className="block font-bold">1</p>
        </div>
        <div>
          <BsBell style={{float: "right"}} />
        </div>
      </div>

      <div className={`p-2 mt-5 score-box-content ${!showDetails ? "grid" : "hidden"}`}>
        <div>
          <div className="w-2 h-2 rounded-full bg-green-400 inline-block mr-2"></div>
          <p className="font-bold inline">Live</p>
        </div>
        <div>
          <p className="font-bold">35`</p>
        </div>
        <div>
          <p className="block font-bold">Wolverhampton</p>
          <p className="block font-bold">Tottenham</p>
        </div>
        <div className="text-right">
          <p className="block font-bold">0</p>
          <p className="block font-bold">1</p>
        </div>
        <div>
          <BsBell style={{float: "right"}} />
        </div>
      </div>
    </>
  );
};

export default ScoreBox;